import {
  GET_PROVIDER_TRADED_AMOUNTS,
  GET_PROVIDER_TRADED_AMOUNTS_ERROR,
  GET_PROVIDER_TRADED_AMOUNTS_SUCCESS
} from './ProviderTradedAmountsSection.actions'

const providerTradedAmountsSectionState = {
  csv: [],
  data: [],
  error: null,
  loading: false,
  totalAmount: 0,
  totalAmountUSD: 0
}

/**
 * The provider traded amounts section's reducer.
 */
const providerTradedAmountsSectionReducer = (state = providerTradedAmountsSectionState, { payload, type }) => {
  switch (type) {
    case GET_PROVIDER_TRADED_AMOUNTS: {
      return { ...state, loading: true }
    }
    case GET_PROVIDER_TRADED_AMOUNTS_ERROR: {
      return { ...state, error: payload.error, loading: false }
    }
    case GET_PROVIDER_TRADED_AMOUNTS_SUCCESS: {
      return { ...state, ...payload, loading: false }
    }
    default: {
      return state
    }
  }
}

export default providerTradedAmountsSectionReducer
